<template>
  <div>
    <router-view :casinoProviders="casinoProviders"></router-view>
  </div>
</template>

<script>
export default {
  data: () => ({
    casinoProviders: [],
  }),
  mounted() {
    this.getCasinoProviders();
  },
  methods: {
    async getCasinoProviders() {
      try {
        const response = await this.$gameApi.get("/admin/casino-providers");
        if (response.data) {
          this.casinoProviders = response.data.filter(
            (provider) => provider.name.toLowerCase() !== "flipmaster"
          );
        }
      } catch (err) {}
    },
  },
};
</script>

<style>
</style>